<template>
    <input type="hidden" name="_token" :value="$csrf_token()">
</template>

<script>
export default {}
</script>
